import React from 'react';  // eslint-disable-line

const Calendar = () => {
    return (
        <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Components-/-Dropdown-/-Button-/-L-/-Normal-Copy" transform="translate(-126.000000, -9.000000)">
                    <g id="Icon" transform="translate(123.000000, 8.000000)">
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                        <path d="M16,1 L16,3 L8,3 L8,1 L6,1 L6,3 L5,3 C3.89,3 3.01,3.9 3.01,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 L18,3 L18,1 L16,1 Z M19,19 L5,19 L5,8 L19,8 L19,19 Z" id="Shape" fill="#616B7D" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Calendar;
